const CODE_ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";

export function randomToken(byteLength = 24) {
  const bytes = crypto.getRandomValues(new Uint8Array(byteLength));
  return Array.from(bytes, (byte) =>
    CODE_ALPHABET.charAt(byte % CODE_ALPHABET.length),
  ).join("");
}

export function normalizeRedemptionCode(value: string) {
  return value.trim().toUpperCase().replace(/\s+/g, "");
}

export async function sha256(value: string) {
  const bytes = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
}

export function createRedemptionCode(prefix = "MJ") {
  const body = randomToken(12);
  return `${prefix}-${body.slice(0, 4)}-${body.slice(4, 8)}-${body.slice(8)}`;
}

export function isValidClientToken(value: unknown): value is string {
  return typeof value === "string" && /^[A-Z0-9_-]{20,96}$/i.test(value);
}
